<template>
    <div class="tap-cont">
        <el-tabs v-model="activeName" @tab-click="handleClick">
            <el-tab-pane label="通用配置" name="first">
                <!-- <div class="view-cont">
                    <div class="show-view">
                        <div class="show-amplify" @click="showCover"></div>
                    </div>
                </div> -->
                <el-form class="tab-cont" ref="basepage" :model="basepage" :rules="baserule">
                    <el-form-item class="tab-item" label="首页标题" prop="title">
                        <el-input v-model="basepage.title" ></el-input>
                    </el-form-item>
                    <el-form-item class="tab-item" label="界面主色" prop="pageColor">
                        <el-color-picker v-model="basepage.pageColor"></el-color-picker>
                        <div class="color">{{basepage.pageColor}}</div>
                    </el-form-item>
                    <div class="tab-item btn-item">
                        <el-button class="all-btn" @click="handleRestartBase">恢复默认</el-button>
                        <el-button type="primary" class="all-btn" @click="submitBasePage('basepage')">保存设置</el-button>
                    </div>
                </el-form>        
            </el-tab-pane>
            <el-tab-pane label="首页" name="second">
                <!-- <div class="view-cont">
                    <div class="show-view">
                        <div class="show-amplify" @click="showCover"></div>
                    </div>
                </div> -->
                <el-form class="tab-cont" ref="homepage" :model="homepage" :rules="homerule">
                    <el-form-item class="tab-item" label="页面风格">
                        <el-select v-model="homepage.pageStyle">
                            <el-option 
                                v-for="item in options"
                                :key="item.value"
                                :label="item.label"
                                :value="item.value">
                            </el-option>
                        </el-select>
                    </el-form-item>
                    <el-form-item class="tab-item" label="首页轮播图1" prop="loopImage1">
                        <div class="img-upload">
                            <div class="img-show"><img v-if="homepage.loopImage1 != ''" :src="homepage.loopImage1"></div>
                            <div>
                                <el-upload
                                    :action="uploadURL"
                                    :headers="headers"
                                    :show-file-list="false"
                                    name="fileName"
                                    :on-success="handleAvatarSuccess1"
                                    :before-upload="beforeAvatarUpload">
                                    <el-button>选择上传</el-button>
                                </el-upload>
                                <div class="img-tip">png格式,800x600,不超过120KB</div>
                            </div>
                        </div>
                    </el-form-item>
                    <el-form-item class="tab-item" label="首页轮播图2" prop="loopImage2">
                        <div class="img-upload">
                            <div class="img-show"><img v-if="homepage.loopImage2 != ''" :src="homepage.loopImage2"></div>
                            <div>
                                <el-upload
                                    :action="uploadURL"
                                    :headers="headers"
                                    :show-file-list="false"
                                    name="fileName"
                                    :on-success="handleAvatarSuccess2"
                                    :before-upload="beforeAvatarUpload">
                                    <el-button>选择上传</el-button>
                                </el-upload>
                                <div class="img-tip">png格式,800x600,不超过120KB</div>
                            </div>
                        </div>
                    </el-form-item>
                    <el-form-item class="tab-item" label="首页轮播图3" prop="loopImage3">
                        <div class="img-upload">
                            <div class="img-show"><img v-if="homepage.loopImage3 != ''" :src="homepage.loopImage3"></div>
                            <div>
                                <el-upload
                                    :action="uploadURL"
                                    :headers="headers"
                                    :show-file-list="false"
                                    name="fileName"
                                    :on-success="handleAvatarSuccess3"
                                    :before-upload="beforeAvatarUpload">
                                    <el-button>选择上传</el-button>
                                </el-upload>
                                <div class="img-tip">png格式,800x600,不超过120KB</div>
                            </div>
                        </div>
                    </el-form-item>
                    <div class="tab-item btn-item">
                        <el-button class="all-btn" @click="handleRestartHome">恢复默认</el-button>
                        <el-button type="primary" class="all-btn" @click="submitHomePage('homepage')">保存设置</el-button>
                    </div>
                </el-form>
            </el-tab-pane>
            <el-tab-pane label="充电详情页" name="third">
                <!-- <div class="view-cont">
                    <div class="show-view">
                        <div class="show-amplify" @click="showCover"></div>
                    </div>
                </div> -->
                <el-form class="tab-cont" ref="chargerpage" :model="chargerpage">
                    <el-form-item class="tab-item" label="充电选项设置">
                        <div class="show-cont">
                            <div class="show-option select-form">
                                <el-checkbox v-model="chargerpage.chargerItem"></el-checkbox>
                                <!-- <el-radio v-model="chargerpage.chargerItem" :label="0"></el-radio> -->
                                <p>优先显示费用</p>
                            </div>
                            <div class="show-img">
                                <div><img src="./images/img1.png" alt=""></div>
                            </div>
                        </div>
                    </el-form-item>
                    <el-form-item class="tab-item" label="支付方式偏好">
                        <div class="show-cont">
                            <div class="show-option select-form">
                                <el-radio v-model="chargerpage.payPreference" :label="0"></el-radio>
                                <p>优先显示支付宝支付选项</p>
                                <el-radio v-model="chargerpage.payPreference" :label="1"></el-radio>
                                <p style="width: 154px;">如果有积分选项，则优先展示积分支付</p>
                            </div>
                            <div class="show-img">
                                <div><img src="./images/img2.png" alt=""></div>
                                <div><img src="./images/img3.png" alt=""></div>
                            </div>
                        </div>
                    </el-form-item>
                    <div class="tab-item btn-item">
                        <el-button class="all-btn" @click="handleRestartCharger">恢复默认</el-button>
                        <el-button type="primary" class="all-btn" @click="submitChargerPage('chargerpage')">保存设置</el-button>
                    </div>
                </el-form>      
            </el-tab-pane>
        </el-tabs>
    </div>
</template>
<script>
import {http, apiJson, baseURL} from '@/utils/http'
import { Message } from 'element-ui';
export default {
    data () {
        return {
            basepage: {
                title: '',
                pageColor: '#3296FA',
                setParams: false
            },
            homepage: {
                pageStyle: 1,
                loopImage1: [],
                loopImage2: [],
                loopImage3: [],
            },
            chargerpage: {
                payPreference: 1,
                chargerItem: false
            },
            activeName: 'first',
            options: [{
                value: 1,
                label: '简洁'
            },
            {
                value: 2,
                label: '多功能'
            }],
                headers: {
                'token': localStorage.getItem('token')
            },
            id: false,
            baserule: {
                title: [
                    {required: true, message: '请输入首页标题', trigger: 'blur'},
                    { min: 1, max: 10, message: '长度在 1 到 10 个字符', trigger: 'blur'}
                ],
                pageColor: [
                    {required: true, message: '请选择主题颜色', trigger: 'blur'}
                ]
            },
            homerule: {
                loopImage1: [
                    {required: true, message: '请上传图片文件', trigger: 'blur'}
                ],
                loopImage2: [
                    {required: true, message: '请上传图片文件', trigger: 'blur'}
                ],
                loopImage3: [
                    {required: true, message: '请上传图片文件', trigger: 'blur'}
                ]
            }
        }  
    },
    created () {
        this.$store.dispatch('changeDefaultActive','page')
        let {params} = this.$route
        this.getAppParam(params.id)
    },
    methods: {
        getAppParam (appId) {
            http(apiJson.getappparam, {appId}).then(res => {
                //console.log(res)
                if(res.code == 0 && res.data != "未查询到指定应用") {
                    this.setParams = true
                    this.getAppPage()
                }else if(res.code == 0) {
                    this.setParams = false
                    Message.warning("请先设置应用参数")
                }else {
                    this.$router.push("/login")
                }
            })
        },
        getAppPage () {
            let {params} = this.$route
            http(apiJson.getAppPage, {appId: params.id}).then(res => {
                //console.log(res)
                if(res.data == null || !res.data.id) {
                    this.id = ''
                }else {
                    this.id = res.data.id
                    this.basepage = {
                        title: res.data.title,
                        pageColor: res.data.pageColor
                    }
                    this.homepage = {
                        pageStyle: res.data.pageStyle > 0 ? res.data.pageStyle : 1,
                        loopImage1: res.data.loopImages ? res.data.loopImages[0] : '',
                        loopImage2: res.data.loopImages ? res.data.loopImages[1] : '',
                        loopImage3: res.data.loopImages ? res.data.loopImages[2] : '',
                    }
                    this.chargerpage = {
                        payPreference: res.data.payPreference,
                        chargerItem: Boolean(res.data.chargerItem)
                    }
                }
            })
        },
        handleRestartBase () {
            this.basepage = {
                title: '',
                pageColor: '#3296FA',
                setParams: false
            }
        },
        handleRestartHome () {
            this.homepage = {
                pageStyle: 1,
                loopImage1: [],
                loopImage2: [],
                loopImage3: [],
            }
        },
        handleRestartCharger () {
            this.chargerpage = {
                payPreference: 1,
                chargerItem: false
            }
        },
        handleClick (tab, event) {
            //console.log(tab, event)
        },
        handleExceed (file, fileList) {
            this.$message.warning("请勿上传多余的文件")
        },
        showCover () {
            this.$store.dispatch('showCoverView')
        },
        handleAvatarSuccess1(res, file) {
            this.homepage.loopImage1 = res.data.url;
        },
        handleAvatarSuccess2(res, file) {
            this.homepage.loopImage2 = res.data.url;
        },
        handleAvatarSuccess3(res, file) {
            this.homepage.loopImage3 = res.data.url;
        },
        beforeAvatarUpload(file) {
            const isJPG = file.type === 'image/png';
            const isLt2M = file.size / 1024 / 1024 < 0.12;

            if (!isJPG) {
            this.$message.error('上传头像图片只能是 PNG 格式!');
            }
            if (!isLt2M) {
            this.$message.error('上传头像图片大小不能超过 120KB!');
            }
            return isJPG && isLt2M;
        },
        submitBasePage (basepage) {
            if(this.setParams) {
                this.$refs[basepage].validate(valid => {
                    if (valid) { 
                        let {params} = this.$route
                        let options = this.basepage
                        this.id ? options.id = this.id : options.appId = params.id
                        let url = this.id ? apiJson.updateBasePage : apiJson.savebasepage
                        http(url, options).then(res => {
                            if(res.code == 0) {
                                Message.success('保存成功')
                                this.getAppPage()
                            }else {
                                Message.warning('保存失败')
                            }
                        })  
                    }
                })
            } else {
                Message.warning("请先设置应用参数")
            }
        },
        submitHomePage (homepage) {
            if(this.setParams) {
                this.$refs[homepage].validate(valid => {
                    if (valid) { 
                        let {params} = this.$route
                        let options = this.homepage
                        if(this.id) {
                            options.id = this.id
                            let url = this.id ? apiJson.updatgeHomePage : apiJson.savehomepage
                            http(url, options).then(res => {
                                if(res.code == 0) {
                                    Message.success('保存成功')
                                    this.getAppPage()
                                }else {
                                    Message.warning('保存失败')
                                }
                            })  
                        }else {
                            Message.warning("请先设置通用配置")
                        }
                        
                    }
                })
            } else {
                Message.warning("请先设置应用参数")
            }
        },
        submitChargerPage (chargerpage) {
            if(this.setParams) {
                this.$refs[chargerpage].validate(valid => {
                    if (valid) { 
                        let {params} = this.$route
                        let options = this.chargerpage
                        if (this.id) {
                            options.id = this.id
                            options.chargerItem = Number(options.chargerItem)
                            let url = this.id ? apiJson.updateChargerPage : apiJson.savechargerpage
                            http(url, options).then(res => {
                                if(res.code == 0) {
                                    Message.success('保存成功')
                                    this.getAppPage()
                                }else {
                                    Message.warning('保存失败')
                                }
                            }) 
                        }else{
                            Message.warning("请先设置通用配置")
                        }
                    }
                })
            } else {
                Message.warning("请先设置应用参数")
            }
        }
    },
    computed: {
        uploadURL () {
            return baseURL + apiJson.fileUpload
        }
    }
}
</script>
<style lang="scss" scoped>
    
    .tap-cont {
        border-left: 1px solid #e5e5e5;
        width: 1110px;
        padding-left: 30px;
        margin-top: 25px;
        & /deep/ .el-tabs__nav-scroll {
            width: 245px;
            margin: 0 auto;
        }
        .el-tab-pane {
            display: flex;
        }
        .el-checkbox {
            width: 23px;
        }
        .view-cont {
            width: 390px;
            height: 880px;
            float: left;
            .show-view {
                width: 260px;
                height: 464px;
                border: 1px solid #cccccc;
                margin: 60px 0 0 115px;
                position: relative;
                .show-amplify {
                    width: 64px;
                    height: 64px;
                    background: url(./images/ic_amplify_normal.png);
                    position: absolute;
                    top: 50%;
                    left: 50%;
                    margin-top: -32px;
                    margin-left: -32px;
                    border-radius: 50%;
                    cursor: pointer;
                }
            }
        }
        .tab-cont {
            // margin: 60px 0 0 160px;
            margin: 60px auto 0;
            .btn-item {
                padding-left: 100px;
            }
            .tab-item {
                display: flex;
                padding-bottom: 20px;
                .el-input {
                    width: 280px;
                }
                .color {
                    width: 100px;
                    height: 36px;
                    line-height: 36px;
                    background: #fff;
                    text-align: center;
                    border-radius: 4px;
                    border: 1px solid #d6d6d6;
                    margin-left: 10px;
                    color: #666666;
                    font-size: 14px;
                    float: right;
                }
                .img-upload {
                    display: flex;
                    .img-show {
                        width: 120px;
                        height: 90px;
                        background: #F0F0F0;
                        border: 1px solid #D6D6D6;
                        margin-right: 30px;
                        img {
                            width: 120px;
                            height: 90px;
                        }
                    }
                    .img-tip {
                        line-height: 20px;
                        font-size: 14px;
                        color: #999999;
                        padding-top: 10px;
                    }
                }
                .el-button.all-btn {
                    color: #333;
                    margin-right: 45px;
                    margin-top: 40px;
                    &.el-button--primary {
                        color: #fff;
                    }
                }
                .show-cont {
                    width: 365px;
                    .show-option {
                        display: flex;
                        .el-radio {
                            width: 23px;
                            text-align: left;
                            padding-top: 9px;
                            span:last-child {
                                display: none;
                            }
                        }
                        p {
                            padding-top: 8px;
                            width: 100px;
                            line-height: 20px;
                            padding-right: 33px;
                            font-size: 14px;
                            color: #666;
                            padding-bottom: 10px;
                        }
                    }
                    .show-img {
                        display: flex;
                        div {
                            width: 100px;
                            height: 180px;
                            margin: 20px 25px;
                            img {
                                width: 100px;
                                height: 180px;
                            }
                        }
                    }
                }
            }   
        }
    }
</style>



// WEBPACK FOOTER //
// src/pages/CreateApp/page.vue